import moment from 'moment';

export function getTime(notificationdate) {
	let timeformat = "Just now";
	let now = moment();
	let end = moment(notificationdate);
	let duration = moment.duration(now.diff(end));
	var days = duration.days();
	var hours = duration.hours();
	var minutes = duration.minutes();
	var seconds = duration.seconds();
	if (days) {
		timeformat = days + 'D';
	} else if (hours) {
		timeformat = hours + 'h';
	} else if (minutes) {
		timeformat = minutes + 'm';
	} else if (seconds) {
		timeformat = seconds + 's';
	}

	return timeformat;
}

export function isRecentNotification(notificationdate) {
var now = moment(new Date()); 
var end = moment(notificationdate); 
var duration = moment.duration(now.diff(end));
var hours = duration.asHours();;
let isnew = (hours < 1);
return isnew;
}
